<template>
  <div>
    <el-dialog
      title="项目立项招标完结"
      :visible="visible"
      width="540px"
      class="splitDialog"
      @close="close"
    >
      <el-form :model="form" ref="form" :rules="rules" class="total-price" label-width="150px">
        <el-form-item prop="winBidResult" label="中标结果">
          <el-select
            v-model="form.winBidResult"
            placeholder="请选择中标结果"
            @change="winBidResultChange"
          >
            <el-option
              v-for="item in bidResultMap"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 已中标选项  start -->
        <el-form-item v-if="form.winBidResult == 'BS01'" prop="winBidAmount" label="中标金额">
          <el-input v-model="form.winBidAmount" type="number"></el-input>
        </el-form-item>
        <el-form-item v-if="form.winBidResult == 'BS01'" prop="winBidContractNo" label="中标合同号">
          <el-input v-model="form.winBidContractNo"></el-input>
        </el-form-item>
        <el-form-item v-if="form.winBidResult == 'BS01'" label="投标管理费">
          <el-input v-model="form.biddingManagementFee" type="number"></el-input>
        </el-form-item>
        <el-form-item v-if="form.winBidResult == 'BS01'" label="投标保证金处理方式">
          <el-select v-model="form.biddingPackageMoneyMethod" clearable placeholder="请选择">
            <el-option label="转为履约保证金" value="转为履约保证金"></el-option>
            <el-option label="不做处理" value="不做处理"></el-option>
          </el-select>
        </el-form-item>
        <!-- 已中标选项  end -->
        <el-form-item v-if="form.winBidResult === 'BS02'" prop="reason" label="未中标原因">
          <el-select v-model="form.reason" placeholder="请选择未中标原因">
            <el-option
              v-for="item in unBidReasonMap"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.winBidResult === 'BS03'" prop="reason" label="弃标原因">
          <el-select v-model="form.reason" placeholder="请选择弃标原因">
            <el-option
              v-for="item in unpidReasonMap"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.winBidResult === 'BS02' || form.winBidResult === 'BS03'"
          prop="specificReason"
          label="具体原因"
        >
          <el-input v-model="form.specificReason"></el-input>
        </el-form-item>
      </el-form>
      <!-- <upload :printShow="true" :tableData="tableData || []" @uploadPrint="uploadPrint" /> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="default" @click="close" class="fixed-bottom-btn">
          关闭
        </el-button>
        <el-button
          size="medium"
          type="primary"
          class="fixed-bottom-btn"
          :loading="load"
          @click="finishProjectHandle"
        >
          确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ProjectApi from '@/api/purchaseSalesCenter/project.js';
  export default {
    name: 'ProjectFinish',
    props: ['visible', 'id', 'isExecuted'],
    model: {
      prop: 'visible',
      event: 'change',
    },
    data() {
      const specialValidate = (rule, value, callback) => {
        if (this.isExecuted) {
          if (value != 'BS01') {
            callback(new Error('中标结果于项目状态不符，请重新选择'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      return {
        // bidResultMap: [
        //   {
        //     label: '未中标',
        //     value: 'BS02',
        //   },
        //   {
        //     label: '已中标',
        //     value: 'BS01',
        //   },
        //   {
        //     label: '弃标',
        //     value: 'BS03',
        //   },
        // ],
        load: false,
        form: {
          winBidResult: '',
          winBidAmount: '',
          winBidContractNo: '',
          biddingManagementFee: '',
          biddingPackageMoneyMethod: '',
          reason: '',
          specificReason: '',
        },
        rules: {
          winBidResult: [
            {
              required: true,
              message: '请选择中标结果',
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          winBidAmount: [
            {
              required: true,
              message: '请输入中标金额',
              trigger: 'blur',
            },
          ],
          winBidContractNo: [
            {
              required: true,
              message: '请输入中标合同号',
              trigger: 'blur',
            },
          ],
          reason: [
            {
              required: true,
              message: '请选择原因',
              trigger: 'blur',
            },
          ],
          specificReason: [
            {
              required: true,
              message: '请填写具体原因',
              trigger: 'blur',
            },
          ],
        },
        unpidReasonMap: [
          {
            label: '主动放弃',
            value: '主动放弃',
          },
          {
            label: '公司撤资',
            value: '公司撤资',
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        dictListMap: (state) => state.dict.dictListMap,
      }),
      bidResultMap() {
        return this.dictListMap ? this.dictListMap['PROJECT_INITIATION_BID_STATUS'] : [];
      },
      unBidReasonMap() {
        return this.dictListMap ? this.dictListMap['PROJECT_INITIATION_UNBID_REASON'] : [];
      },
    },
    methods: {
      // 关闭项目完结弹窗
      close() {
        this.$emit('change', false);
        this.$refs.form.resetFields();
      },
      winBidResultChange() {
        this.form.winBidAmount = '';
        this.form.winBidContractNo = '';
        this.form.biddingPackageMoneyMethod = '';
        this.form.biddingManagementFee = '';
        this.form.reason = '';
        this.$refs.form.clearValidate();
      },
      // 项目完结确认
      async finishProjectHandle() {
        if (this.load) return;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.load = true;
            const params = Object.assign({}, this.form, { id: Number(this.id) });
            this.$axios.post(ProjectApi.BID_FINISH, params).then((res) => {
              this.load = false;
              if (0 == res.data.code) {
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.$emit('change', false);
                this.$emit('refresh');
              } else {
                this.$alert(res.data.msg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
